import { Typography } from "@mui/material";
import { colorPrimary } from "../../../theme";

interface LaudoCautelarLinkProps {
  anuncioId?: number;
  laudo?: string | null;
}

export function LaudoCautelarLink({
  anuncioId,
  laudo,
}: LaudoCautelarLinkProps) {
  if (!laudo || !anuncioId) {
    return (
      <Typography fontWeight={600} fontSize="1.2rem">
        Nenhum arquivo.
      </Typography>
    );
  }

  return (
    <a
       href={laudo?.includes('hmlv2api.avaliadordigital')? laudo : laudo?.includes("veiculos")? laudo: `https://www.canaldorepasse.com.br/anuncios/fotos/${anuncioId}/${laudo}`}
      target="_blank"
      rel="noopener noreferrer"
      style={{ textDecoration: "none" }}
    >
      <Typography
        fontWeight={400}
        fontSize="1rem"
        color={colorPrimary}
        sx={{
          cursor: "pointer",
          "&:hover": {
            textDecoration: "underline",
          },
        }}
      >
        Visualizar laudo cautelar
      </Typography>
    </a>
  );
}
